import {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useLocation } from 'react-router-dom';

const NavigationHistoryContext = createContext({ previousPath: null });

export function NavigationHistoryProvider({ children }) {
  const location = useLocation();
  const [previousPath, setPreviousPath] = useState(null);
  const currentPathRef = useRef(location.pathname);

  useEffect(() => {
    if (location.pathname !== currentPathRef.current) {
      setPreviousPath(currentPathRef.current);
      currentPathRef.current = location.pathname;
    }
  }, [location.pathname]);

  const value = useMemo(() => ({ previousPath }), [previousPath]);

  return (
    <NavigationHistoryContext.Provider value={value}>
      {children}
    </NavigationHistoryContext.Provider>
  );
}

export function usePreviousPath() {
  return useContext(NavigationHistoryContext).previousPath;
}